import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable, shareReplay } from 'rxjs';
import {
  ApiUploadDocType,
  UploadDocType,
} from './gk-kendo-upload-doc-type-dictionary.model';
import { UploadDocTypeName } from '../gk-kendo-upload.model';
import { ApiResponse } from '../../../services';

@Injectable({
  providedIn: 'root',
})
export class GkKendoUploadDocTypeDictionaryService {
  private cache: { [key in UploadDocTypeName]?: Observable<UploadDocType[]> } =
    {};

  constructor(private httpClient: HttpClient) {}

  getDocTypes(docTypeName: UploadDocTypeName): Observable<UploadDocType[]> {
    if (!this.cache[docTypeName]) {
      const url = this.getUrlForDocType(docTypeName);
      this.cache[docTypeName] = this.fetchDocTypes(url).pipe(shareReplay(1));
    }

    return this.cache[docTypeName]!;
  }

  private getUrlForDocType(docTypeName: UploadDocTypeName): string {
    switch (docTypeName) {
      case UploadDocTypeName.Default:
        return '/api/eod/slo/kdokrodz/portal';
      case UploadDocTypeName.WorkReports:
        return '/api/geodeta/slo/operat/kdokrodz';
      case UploadDocTypeName.Work:
        return '/api/geodeta/slo/praca/kdokrodz';
      case UploadDocTypeName.FeeConfirmation:
        return '/api/eod/slo/kdokrodz/potwierdzeniezaplaty';
      case UploadDocTypeName.CoordinationMeetingPortalCase:
        return '/api/zudp/branzysta/sprawy/slo/kdokrodz';
      case UploadDocTypeName.EodKdokrodz:
        return '/api/eod/slo/kdokrodz';
      default:
        throw new Error(`Unknown doc type: ${docTypeName}`);
    }
  }

  private fetchDocTypes(url: string): Observable<UploadDocType[]> {
    return this.httpClient.get<ApiResponse<ApiUploadDocType[]>>(url).pipe(
      map((res) => res.Response),
      map((apiFields) =>
        apiFields.map((apiField) => UploadDocType.fromApiToApp(apiField)),
      ),
    );
  }
}
